module.exports = __webpack_public_path__ + "img/14.9d0cfce5.svg";